import { Checkbox, Divider, Dropdown, Table  ,Tag, Row,Col,Space, Popconfirm } from "antd";
import { Link } from "react-router-dom";
import { firstLetterCaps, safePeek } from "../../helpers/helper";
import {EditOutlined} from '@ant-design/icons'
import { getIcon } from "./FuzzyIcon";
import { useEffect, useMemo, useState } from "react";
import ExtraOptions from "./ExtraOptions";
import { DownOutlined } from "@ant-design/icons";

const EditableCell = ({
  editKey,
  editableKey,
  setEditableKey,
  onEditStart,
  onEditComplete,
  onEditCancel,
  hasDelete,
  onDelete,
  canDeleteKeys
}) => {
  return (
    <div className="max-w-[150px] min-w-[100px]">
      {!(editableKey == editKey) ? (
        <>
        <a
          className="text-blue-700"
          onClick={() => {
            onEditStart(editKey);
            setEditableKey(editKey);

          }}
        >
          Edit
        </a>

        {hasDelete && (( typeof canDeleteKeys == "string" && canDeleteKeys == "all") || ((canDeleteKeys instanceof Set) && canDeleteKeys.has(editKey)) ) &&

          <Popconfirm okText="Delete"  onConfirm={()=>onDelete(editKey)} description={"Sure you want to delete ?"}>
          <Divider type="vertical" />
          <a

            className="text-blue-700"
          >
            Delete
          </a>
          </Popconfirm>
         }</>
      ) : (
        <>
          <a
            className="text-blue-700"
            onClick={() => {
              onEditComplete(editKey);
              setEditableKey("");

            }}
          >
            Save
          </a>
          <Divider type="vertical" />
          <a
            onClick={() => {
              onEditCancel(editKey);
              setEditableKey("");

            }}
            className="text-blue-700"
          >
            Cancel
          </a>
        </>
      )}
    </div>
  );
};
const TableView = ({
  dataKey,
  onPageChange,
  pageLimit,
  totalData,
  rowKey,
  columns,
  title,
  data,
  expandable,
  renderFunctions,
  onlyFields,
  editShow,
  editableCallback,
  rowSelection,
  hasEditableRow,
  showHideColumns = [],
  onEditStart,
  onEditCancel,
  onEditComplete,
  editOnlyOne = true,
  hasDelete = false ,
  canDeleteKeys = "all" ,
  onDelete,
  actionMenu,
  forceEditableKey = ""


}) => {
const [editableKey , setEditableKey] = useState("")
const [hiddenColumns , setHiddenColumns]= useState(showHideColumns)
const checkSetEditableKey = (key) => {

  if (editableKey === ""){
    setEditableKey(key)
  } else {
    if (editOnlyOne){
      onEditCancel(editableKey)
      setEditableKey(key)
    }
  }

}


useEffect(()=>{
  if (forceEditableKey!="") setEditableKey(forceEditableKey)
},[forceEditableKey])

  if (showHideColumns.length) {
    const listItems = showHideColumns.map((item)=>{
      return {
        label : (<Checkbox onChange={(e)=>{
          let tmpHiddenColumns = [...hiddenColumns]
          if (e.target.checked){

            tmpHiddenColumns = tmpHiddenColumns.filter(col=>col!=item)
            setHiddenColumns(tmpHiddenColumns)
          } else {

            tmpHiddenColumns.push(item)
            setHiddenColumns(tmpHiddenColumns)
          }
        }} >{item}</Checkbox>)
      }
    })
    title = (
      <Row>
        <Col span={20}><div className="text-[16px] font-bold">{title}</div></Col>
        <Col span={4}>
          <Dropdown className="float-right" menu={{ items: listItems }}>
            <a onClick={e => e.preventDefault()}>
            <Tag >
              Hidden Columns

            </Tag>
          </a>
          </Dropdown>
        </Col>
      </Row>
    );
  }

  if (
    (columns == undefined || columns.length == 0) &&
    data &&
    data.length > 0
  ) {
    columns = [];
    let fields = Object.keys(data[0]);
    if (onlyFields) {
      fields = onlyFields;
    }

    for (var key of fields) {
      if (key instanceof Object) {
        columns.push({
          title: getIcon(firstLetterCaps(Object.keys(key)[0]),true,{size:20,title:firstLetterCaps(Object.keys(key)[0])}),
          key: Object.keys(key)[0],
          dataIndex: Object.values(key)[0],
        });
      } else {
        if (renderFunctions && key in renderFunctions) {
          columns.push({
            title: getIcon(firstLetterCaps(key),true,{size:20,title:firstLetterCaps(key)}),
            key: key,
            dataIndex: key,
            render: renderFunctions[key],
          });
        } else {
          columns.push({
            title: getIcon(firstLetterCaps(key),true,{size:20,title:firstLetterCaps(key)}),
            key: key,
            dataIndex: key,
          });
        }
      }
    }
    if (editableCallback ){
    columns.push({
      title : getIcon("action",true,{size:20,title:firstLetterCaps("action")}),
      key : 'action',
      dataIndex : 'action',
      render : (_,record) => {
        if(editableCallback && actionMenu){
          if(editShow){
            const edit = editShow(record)
            if(edit != true){
              return <>{edit}</>
            }
          }
           return (<><Tag style={{cursor:'pointer'}} onClick={(e)=>editableCallback(record)}>Edit</Tag>
           {actionMenu(record)}</>
           )
        }
        if(editableCallback){
          if(editShow){
            if(editShow(record) == false){
              return <></>
            }
          }
        return (<Tag style={{cursor:'pointer'}} onClick={(e)=>editableCallback(record)}>Edit</Tag>)
        }


      }
    })
  }

  }
   if (hasEditableRow){
    if (columns.length && columns[columns.length-1]['key'] != 'action')
    columns.push({
      title : getIcon("action",true,{size:20,title:firstLetterCaps("action")}),
      key : 'action',
      width:"10%",
      dataIndex : 'action',
      render : (_,record) => {
        return (<EditableCell canDeleteKeys={canDeleteKeys} onDelete={onDelete} hasDelete={hasDelete} editableKey={editableKey} setEditableKey={checkSetEditableKey} editKey = {record.key} onEditCancel={onEditCancel} onEditStart={onEditStart} onEditComplete={onEditComplete} /> )
      }
    })
  }
  if (hiddenColumns.length){
  columns = columns.filter(col=> !(new Set(hiddenColumns).has(col.key)))
  }
  columns = columns?.filter(col => {
  // must have dataIndex
    if (!col.dataIndex) return true;

    // if has render, keep it
    if (col.render) return true;

    // keep column if at least one row has that key defined
    return data.some(row => row[col.dataIndex] !== undefined);
  });
  return (
    <Table
      rowSelection={rowSelection}
      rowKey={rowKey}
      dataSource={data ?? []}
      columns={columns}
      title={title ? () => <div className="text-[16px] font-bold">{title}</div> : undefined}
      pagination={{
        pageSizeOptions: [pageLimit],
        total: totalData ?? data?.length,
        pageSize: pageLimit,
        position: ["bottomLeft"],
        onChange: (pageNum) => {

          onPageChange(pageNum);
        },
      }}

      expandable={expandable}
      scroll={true}
    />
  );
};

export default TableView;
